// extracted by mini-css-extract-plugin
module.exports = {"frame":"frame_frame__2Ryb8","mainPage":"frame_mainPage__3nSz5"};